// extracted by mini-css-extract-plugin
export var featureWrapperTextLeft = "index-module--feature-wrapper-text-left--5KjjW";
export var featureWrapperTextRight = "index-module--feature-wrapper-text-right--HsU5e";
export var imageWrapperTextLeft = "index-module--image-wrapper-text-left--SdJx8";
export var imageWrapperTextRight = "index-module--image-wrapper-text-right--6-YHr";
export var img = "index-module--img--MEjbv";
export var text = "index-module--text--xvP0P";
export var textWrapper = "index-module--text-wrapper--zUGRW";
export var title = "index-module--title--Z-N+R";